import React from 'react';
import { Ban, FileCheck2, Mail, QrCode, Scale, ShieldAlert, SearchCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { toBn } from '../../utils/bangla';
const steps = [{
  icon: Mail,
  title: 'ডিএমপির নোটিশ গ্রহণ করুন।',
  desc: 'ডাকযোগে প্রাপ্ত নোটিশে ডিএমপির লেটারহেড, স্মারক নম্বর ও QR যাচাই ব্লক আছে কি না দেখুন।',
  color: '#003B71'
}, {
  icon: QrCode,
  title: 'QR কোড স্ক্যান করুন।',
  desc: 'নোটিশের নিচে বাম পাশের QR কোড মোবাইল ক্যামেরায় স্ক্যান করুন।',
  color: '#1769AA',
  link: '/citizen/scan'
}, {
  icon: SearchCheck,
  title: 'মামলার তথ্য যাচাই করুন।',
  desc: 'মামলা নম্বর, গাড়ির নম্বর ও তারিখ নোটিশের সাথে মিলিয়ে দেখুন।',
  color: '#006A4E',
  link: '/citizen/manual'
}, {
  icon: FileCheck2,
  title: 'অফিসিয়াল নোটিশের কপি দেখুন।',
  desc: 'যাচাই পেজ থেকে ডিএমপির অফিসিয়াল নোটিশের কপি দেখুন বা ডাউনলোড করুন।',
  color: '#16834A'
}, {
  icon: Ban,
  title: 'অপরিচিত SMS বা লিংকে অর্থ প্রদান করবেন না।',
  desc: 'ডিএমপি কখনো SMS লিংক বা ব্যক্তিগত নম্বরে অর্থ দাবি করে না।',
  color: '#D93036'
}, {
  icon: ShieldAlert,
  title: 'সন্দেহজনক নোটিশ রিপোর্ট করুন।',
  desc: 'সন্দেহজনক SMS বা নোটিশের স্ক্রিনশট/ছবিসহ অভিযোগ জমা দিন।',
  color: '#E69A20',
  link: '/citizen/report'
}];
export function CitizenGuidelines() {
  return <div className="mx-auto max-w-5xl px-4 py-8" data-id="element-1854" data-mp="2gvdfng6jthum">
      <h1 className="text-2xl font-bold text-[#003B71]" data-id="element-1855" data-mp="2lnwtme95eezy">নাগরিক নির্দেশনা</h1>
      <p className="mt-1 text-slate-600" data-id="element-1856" data-mp="2pp092znaa90n">ট্রাফিক প্রসিকিউশন নোটিশ পেলে নিরাপদে যাচাই করার ধাপসমূহ</p>
      <ol className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-1857" data-mp="2uo337p1q6utu">
        {steps.map((s, i) => {
        const Icon = s.icon;
        const body = <div className="h-full rounded-xl border border-border bg-white p-5 transition-shadow hover:shadow-md" data-id="element-1858" data-mp="2znpevu1wo30j">
              <div className="flex items-center gap-3" data-id="element-1859" data-mp="34k6epligw5tg">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl text-white" style={{
              backgroundColor: s.color
            }} data-id="element-1860" data-mp="15a6nz32drio7"><Icon className="h-6 w-6" data-id="element-1861" data-mp="1a8rol3ljo4d6" /></span>
                <span className="text-3xl font-bold text-slate-200" data-id="element-1862" data-mp="127a97kbjjgrj">{toBn(i + 1)}</span>
              </div>
              <h2 className="mt-4 text-[17px] font-bold text-slate-900" data-id="element-1863" data-mp="x8z05bt2laad">{toBn(i + 1)}. {s.title}</h2>
              <p className="mt-1 text-sm leading-relaxed text-slate-600" data-id="element-1864" data-mp="1c698wdebw22e">{s.desc}</p>
            </div>;
        return <li key={s.title} data-id="element-1865" data-mp="175lhvrq3nl86" data-mpi={i}>{s.link ? <Link to={s.link} data-id="element-1866" data-mp="175br41x8da1f">{body}</Link> : body}</li>;
      })}
      </ol>
      <div className="mt-6 flex items-start gap-3 rounded-xl border border-[#006A4E]/30 bg-[#F2F8F5] p-5" data-id="element-1867" data-mp="1l5cvhrcpezln">
        <Scale className="mt-0.5 h-6 w-6 text-[#006A4E]" data-id="element-1868" data-mp="1g6jq6m7kmewk" />
        <p className="text-sm text-slate-700" data-id="element-1869" data-mp="1uvxzxvf26ych">নোটিশে উল্লিখিত হাজিরার তারিখ ও সময়ে নির্ধারিত কার্যালয়ে উপস্থিত হয়ে আইনগত নির্দেশনা অনুসরণ করুন। যাচাই ব্যর্থ হলে আতঙ্কিত হবেন না — পুনরায় চেষ্টা করুন অথবা সংশ্লিষ্ট ট্রাফিক বিভাগে যোগাযোগ করুন।</p>
      </div>
    </div>;
}